import {Component} from '@angular/core';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {CsvErrorsService} from '@drl/shared/facades/csv-errors.service';
import {CsvUploadReport} from '@drl/shared/models/csv-upload-report.model';
import {csvTypeMap} from '@drl/shared/utility/csv-type.utility';
import {TranslateService} from '@ngx-translate/core';
import {SystemStoreFacadeService} from '@drl/core/store/system-store-facade.service';
import {Router} from '@angular/router';
import {environment} from '@drl/env/environment';
import {ComponentBase} from '@drl/core/component-base';

@Component({
  selector: 'app-csv-upload-report',
  templateUrl: './csv-upload-report.component.html',
  styleUrls: [],
})
export class CsvUploadReportComponent extends ComponentBase {
  constructor(
    private readonly csvErrorsReport: CsvErrorsService,
    private readonly translateSvc: IpsTranslateService,
    private readonly systemStoreFacade: SystemStoreFacadeService,
    private readonly router: Router,
  ) {
    super();
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;
  csvTypeLbl: string;
  errReport: CsvUploadReport;
  loading = false;
  ngOnInit() {
    this.loading = true;
    this.initErrReport();
  }
  getCsvTypeByLocale() {
    this.systemStoreFacade.getLocale().subscribe(
      locale => {
        this.csvTypeLbl = csvTypeMap(this.translateSvc.translate, locale)[
          this.errReport.csvType
        ].name;
        this.loading = false;
      },
      err => {
        this.loading = false;
      },
    );
  }
  initErrReport() {
    this._subscriptions.push(
      this.csvErrorsReport.csvErrors.subscribe(errReport => {
        if (!errReport) {
          this.loading = false;
          this.router.navigate([environment.homePath]);
        } else {
          this.errReport = errReport;
          this.getCsvTypeByLocale();
        }
      }),
    );
  }
}
